<template>
  <!-- 供应商管理 -->
  <div>
    <!-- 搜索 -->
    <div>
      <el-input
        style="width: 300px; margin-right: 10px"
        prefix-icon="el-icon-edit"
        v-model="name"
        size="mini"
        placeholder="请输入供应商名称"
        clearable
      >
      </el-input>
      <span style="margin-right: 10px"></span>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        size="mini"
        @click="onSearch"
        >搜索
      </el-button>
    </div>
    <!-- 表格 -->
    <div>
      <!-- 新增及删除 -->
      <div class="handle_box">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd()"
          >新增</el-button
        >
        <!-- <el-button type="danger" icon="el-icon-delete" @click="deleteRow()"
          >删除
        </el-button> -->
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="calc(100vh - 295px)"
        @row-dblclick="updateRecordView"
      >
        <el-table-column
          prop="name"
          label="供应商名称"
          width="280"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="linkMan"
          label="联系人"
          width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系电话"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="联系地址"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="remarks"
          label="备注"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column align="center" prop="cz" label="操作" width="145px">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="编辑供应商信息"
              placement="top"
            >
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-edit"
                @click="goRedact(scope, tableData)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="删除数据"
              placement="top"
            >
              <el-button
                v-if="scope.row.goodsFlag == 0"
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-delete"
                @click="deleteRow(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[5,10, 20, 50, 100, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框 -->
    <el-dialog
      :title="titleType"
      width="50%"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <el-card class="box-card">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-form-inline"
          label-position="right"
        >
          <el-form-item label="供应商名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人" prop="linkMan">
                <el-input v-model="ruleForm.linkMan"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="ruleForm.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属省" prop="province">
                <el-select
                  v-model="ruleForm.province"
                  placeholder="请选择"
                  @change="changeSelect"
                >
                  <el-option
                    v-for="(item, i) in procedureType"
                    :key="i"
                    :label="item.provinceName"
                    :value="item.provinceCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属市" prop="city">
                <el-select v-model="ruleForm.city" placeholder="请选择">
                  <el-option
                    v-for="(item, i) in causeGroup"
                    :key="i"
                    :label="item.cityName"
                    :value="item.cityCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="供应商地址" prop="address" width="300px">
            <el-input v-model="ruleForm.address"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input type="textarea" v-model="ruleForm.remarks"></el-input>
          </el-form-item>
          <!-- <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item> -->
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer" v-if="flag">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm', 'add')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  postProvinces,
  postCitys,
  supplierList,
  addSupplier,
  deleteSupplier,
  querySupplier,
  updateSupplier,
} from "../../../api/SlmsData/Supplier";
import { isPhone } from "../../../utils/validate";
export default {
  data() {
    return {
      name: "", //供应商名称
      tableData: [],
      ruleForm: {
        name: "",
        linkMan: "",
        phone: "",
        province: "",
        city: "",
        address: "",
        remarks: "",
      },
      total: 0,
      multipleSelection: [],
      dialogFormVisible: false,
      titleType: "",
      rules: {
        name: [
          { required: true, message: "请填写供应商名称", trigger: "change" },
        ],
        linkMan: [
          { required: true, message: "请填写联系人", trigger: "change" },
        ],
        phone: [
          {
            required: true,
            trigger: "change",
            message: "请填写正确的手机号码",
            validator: (rule, value, callback) => {
              if (value == null || value == undefined || value == "") {
                callback(new Error("请填写正确的手机号码"));
              } else {
                if (!isPhone(value)) {
                  callback(new Error("手机号码格式不正确"));
                  console.log(!isPhone(value));
                } else {
                  callback();
                }
              }
            },
          },
        ],
        province: [
          { required: true, message: "请选择所属省", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择所属市", trigger: "change" }],
        address: [
          { required: true, message: "请填写供应商地址", trigger: "change" },
        ],
      },
      procedureType: [], //省份信息
      causeGroup: [], //市级信息
      page: 1, //页码
      limit: 10, //1页记录数
      requestApi: true, //true新增,false修改
      flag: true, //查看时禁止修改
    };
  },
  created() {
    this.ProvincesData();
    this.searchButton();
  },
  methods: {
    //头部客户查询
    // 搜索/筛选入口：先回到第 1 页再查（避免在第 N 页搜索时结果不足一页而显示空白）
    onSearch() {
      this.page = 1;
      this.searchButton();
    },

    async searchButton() {
      let res = await supplierList(this.page, this.limit, this.name);
      this.tableData = res.data;
      this.total = res.count;
    },
    //请求获取省份信息
    async ProvincesData() {
      this.procedureType = await postProvinces();
    },
    // 省份二级联动请求市级信息
    async changeSelect() {
      this.ruleForm.city = "";
      this.causeGroup = await postCitys(this.ruleForm.province);
    },

    //新增客户信息
    handleAdd() {
      this.titleType = "新增供应商信息";
      this.dialogFormVisible = true;
    },
    //双击表格打开弹窗
    async updateRecordView(row) {
      this.titleType = "查看供应商信息";
      let res = await querySupplier(row.id);
      this.ruleForm = res.result;
      this.causeGroup = await postCitys(this.ruleForm.province);
      this.dialogFormVisible = true;
      this.flag = false;
    },
    //提交新增供应商信息
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$notify({
            title: "操作失败",
            dangerouslyUseHTMLString: true,
            message: "请填写完整",
            type: "warning",
          });
          return;
        }
        let resdata = {};
        try {
          if (this.requestApi) {
            resdata = await addSupplier(this.ruleForm);
            this.$refs["ruleForm"].resetFields();
          } else {
            resdata = await updateSupplier(this.ruleForm);
          }
        } catch (e) {
          console.error("接口异常");
        }
        this.searchButton();
        this.$notify({
          title: resdata ? "成功" : "失败",
          dangerouslyUseHTMLString: true,
          message: resdata ? resdata.message : "服务器开小差了，请稍后再试",
          type: resdata ? "success" : "warning",
        });
      });
    },
    //删除单个
    deleteRow(row) {
      this.$confirm("确定删除吗?", "删除", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let R = await deleteSupplier({ id: row.id });
          this.searchButton();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //编辑供应商信息
    async goRedact(scope) {
      this.titleType = "修改供应商信息";
      let res = await querySupplier(scope.row.id);
      //处理多余数据
      let { id, name, linkMan, phone, province, city, address, remarks } =
        res.result;
      let sx = {
        id: id,
        name: name,
        linkMan: linkMan,
        phone: phone,
        province: province,
        city: city,
        address: address,
        remarks: remarks,
      };
      this.ruleForm = sx;
      this.causeGroup = await postCitys(this.ruleForm.province);
      this.dialogFormVisible = true;
      this.requestApi = false;
      this.flag = true;
    },
    //清空
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //关闭弹窗前回调
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.ruleForm = {};
          this.flag = true;
        })
        .catch((_) => {});
    },
    //分页
    currentChange(currentPage) {
      this.page = currentPage;
      this.searchButton();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.searchButton();
    },
  },
};
</script>

<style lang="scss" scoped>
.handle_box {
  margin: 1vh 0;
}
</style>